import { gql } from "@apollo/client";
import { ViewingRoom } from "../fragments";

const FETCH_VIEWING_ROOM = gql`
  query FetchViewingRoom($input: ViewingRoomListFilter) {
    viewingRooms(input: $input) {
      ${ViewingRoom}
    }
  }
`;

const FETCH_SITE_VIEWING_ROOMS = gql`
  query FetchSiteViewingRooms($input: ViewingRoomListFilter) {
    viewingRooms(input: $input) {
      ${ViewingRoom}
      locationCount
    }
  }
`;

export { FETCH_SITE_VIEWING_ROOMS, FETCH_VIEWING_ROOM };
